module.exports = __webpack_public_path__ + "img/attendclassbg.b8aedfd3.png";